let MAZDA_CONFIG = window.MAZDA_CONFIG;
if(!MAZDA_CONFIG) {
    console.error('MAZDA_CONFIG is not defined!');
}

export const basename = MAZDA_CONFIG.basename;
export const api_url_prefix = MAZDA_CONFIG.api_url_prefix;
export const startTime = MAZDA_CONFIG.startTime;
export const endTime = MAZDA_CONFIG.endTime;
export const alertTxt = MAZDA_CONFIG.alertTxt;

console.info('Using Configuration: ', {
    basename,
    api_url_prefix,
    startTime,
    endTime,
    alertTxt
});

export const use_mock_api = false;


// WEBPACK FOOTER //
// ./src/env/env.prod.js